<template>
    <div class="card" style="min-height: 200px">
        <div class="bg-blue-light p-1">
            <TitleButton
                btnTitle="Add New"
                :showBtn="false"
                :showAddNew="true"
                title="Hotel Invoice list"
                @onClickAddNewButton="navigateToAddPage"
            />
        </div>

        <div class="my-2 px-2">
            <DateQuerySetter btnTitle="Go" @onClickGo="onClickGo"/>
        </div>

        <div class="col-12 px-2 mt-2 table-responsive">
            <table class="table">
                <thead>
                    <tr>
                        <th>Invoice No</th>
                        <th>Invoice Date</th>
                        <th>Guest</th>
                        <th>Room</th>
                        <th class="text-end">Bill Amount</th>
                        <th>Status</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, i) in billList" :key="i">
                        <td>{{ item.bill_number }}</td>
                        <td>{{ item.date }}</td>
                        <td>{{ item.party_name }}</td>
                        <td>{{ roomName(item) }}</td>
                        <td class="text-end">{{ item.bill_amount }}</td>
                        <td>{{ item.status }}</td>
                        <td>
                            <button class="btn btn-primary btn-sm" @click="goToEdit(item.id)" v-if="item.status !== 'returned'">
                                <i class="fas fa-pencil"></i>
                            </button>
                        </td>
                    </tr>
                    <tr v-if="!billList.length">
                        <td colspan="7" class="text-center">No data</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="px-2">
            <Pagination :offset="offset" @onPageChange="onPageChange"/>
        </div>
    </div>
</template>

<script setup>
import TitleButton from '@/components/atom/TitleButton';
import DateQuerySetter from '@/components/atom/DateQuerySetter';
import Pagination from '@/components/atom/Pagination';
import { ref } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import handlePurchase from '@/services/modules/purchase';

const $route = useRoute();
const $router = useRouter();
const $store = useStore();
const { fetchSalesList } = handlePurchase();

const offset = ref(20);
const billList = ref([]);

const getRegisterId = () => {
    return $route.params.ipdRegisterId || $route.query.ipd_register_id;
};

const getQuery = () => {
    let query = `?company_id=${$route.params.companyId}`;
    query += `&ipd_register_id=${getRegisterId()}`;
    query += '&exclude_sale_type=ipd_pharmacy_invoice';
    if ($route.query.page) query += '&page=' + $route.query.page;
    query += '&offset=' + offset.value;
    return query;
};

const onClickGo = () => {
    fetchSalesList(getQuery()).then(res => {
        if (!res.status) {
            billList.value = [];
            $store.commit('resetPagination');
            return;
        }
        billList.value = res.date.data;
        setPagination(res.date);
    });
};

const setPagination = (data) => {
    if (!data.data.length) return;
    $store.commit('setPaginationData', {
        records: data.total,
        perPage: data.per_page,
        currentPage: data.current_page,
    });
};

const roomName = (item) => {
    if (!item.ipd_register) return '';
    if (!item.ipd_register.service_resource) return '';
    return item.ipd_register.service_resource.name;
};

const navigateToAddPage = () => {
    const query = Object.assign({}, $route.query, {
        back_url: encodeURIComponent($route.fullPath),
        bill_title: 'Create Hotel Bill',
    });
    $router.push({
        name: 'ipd-bill-add',
        params: Object.assign({}, $route.params, { ipdRegisterId: getRegisterId() }),
        query: query,
    });
};

const goToEdit = (ipdId) => {
    const query = Object.assign({}, $route.query, {
        back_url: encodeURIComponent($route.fullPath),
        bill_title: 'Update Hotel Bill',
    });
    $router.push({
        name: 'ipd-bill-edit',
        params: {
            companyId: $route.params.companyId,
            moduleId: $route.params.moduleId,
            menuId: $route.params.menuId,
            pageId: $route.params.pageId,
            ipdId: ipdId,
            ipdRegisterId: getRegisterId(),
        },
        query: query,
    });
};

const onPageChange = async (page) => {
    const routeQuery = Object.assign({}, $route.query, { page });
    await $router.push({ path: $route.path, query: routeQuery });
    onClickGo();
};

onClickGo();
</script>
